module.exports = __webpack_public_path__ + "static/cover-3b8248b03a233b0c745ad4a0963651d7.jpg";